import "./CommunityName.css";
import { toastify } from "../../../../helpers/toast/toastify";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import crossBlack from "../../../../assets/images/onboardingImages/crossBlack.svg";
import FloatingTextFiled from "../../../sharedPages/CommonComponents/FloatingTextFiled/FloatingTextFiled";
import InfoPopup from "../../../sharedPages/CommonComponents/InfoPopup/InfoPopup";
import logo_black from "../../../../assets/images/onboardingImages/logo_black.svg";
import longArrow from "../../../../assets/images/onboardingImages/longArrow.svg";
import Modal from "react-bootstrap/Modal";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { fetchUser } from "../../../../helpers/helper";
import {
  resetOnBoardingStartContext,
  storeUser,
} from "../../../../redux/users/usersSlice";
import { setCurrentCommunity, setRefetchMultiCommunityList, setRefetchSpecificUser } from "../../../../redux/multicommunity/multicommunity";
import { useSelector, useDispatch } from "react-redux";
import CloseModal from "../../OnboardingCL/CreateSubscription/CloseModal";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";

const CommunityName = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState("");
  const [alreadyCreatedName, setAlreadyCreatedName] = useState("");
  const [show, setShow] = useState(true);
  const [warn, setWarn] = useState(false);
  const [communityCreated, setCommunityCreated] = useState(false);
  const onBoardingStartContext = useSelector(
    (state) => state.user?.onBoardingStartContext
  );
  
  const selectedCommunity = useSelector(
    (state) => state?.multiCommunity?.currentCommunity
  );
  
  const api = useApi();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const [previousCommunityConnected, setPreviousCommunityConnected] = useState(!!(user?.binanceCredentials?.isConnected&&user?.leaderCommunity) || !!(user?.bybitCredentials?.isConnected&&user?.leaderCommunity));
  const isConnected =
    user?.binanceCredentials?.isConnected ||
    user?.bybitCredentials?.isConnected;
  const dispatch = useDispatch();
  const isOnBoardingComplete =
  user?.onboarding?.isCommunityCreated &&
  user?.onboarding?.connect &&
  user?.onboarding?.payment &&
  user?.onboarding?.subscribed &&
  user?.onboarding?.isVerified;
  const handleClose = () => {
    if (onBoardingStartContext) {
      setShow(false);
      dispatch(resetOnBoardingStartContext());
      navigate(onBoardingStartContext, { replace: true });
      return;
    }
    navigate("/leader/dashboard", { replace: true });
    setShow(false);
  };
  useEffect(()=>{
    if((!isOnBoardingComplete&&user?.leaderCommunity)){
      navigate("/leader/dashboard", { replace: true });
      return;
     }
  },[])
  useEffect(() => {
    if (!(user?.onboarding?.community || []).length) {
      setName(selectedCommunity?.disPlayName);
      setAlreadyCreatedName(selectedCommunity?.disPlayName);
    }
  }, []);
  const fetchOtherCommunitiesCredentials = async () => {
    try {
      const response = await api(
        "get",
        "multiCommunity/otherCommunitiesCredentials"
      );
      if (response?.status && Array.isArray(response.data)) {
        const matchedOption = response.data.find(
          (option) =>
            option.userid === user.previousCommunityUserId
        );
        return response.data;
      }else{
        return [];
      }
    } catch (error) {
      console.error("Error fetching other communities credentials:", error);
    }
  };

  const handleNext = async () => {
    const trimmedName = name?.trim();

    if (!trimmedName) {
      toastify("Community name is required");
      return;
    }

    if (trimmedName.length > 30) {
      toastify("Community Name must not be greater than 30 characters");
      return;
    }

    if (alreadyCreatedName === trimmedName && isConnected) {
      navigate("/leader/onboarding/subscription", {
        replace: true,
      });
      return;
    }

    setIsLoading(true);

    try {
      const response = await api("post", "multiCommunity/createCommunity", {
        communityName: trimmedName,
        oldNmae: alreadyCreatedName,
      });
     
      if (response?.status) {
        const {community}=response?.data;
        dispatch(setCurrentCommunity(community));
        const responseSpecificUser = await api("post", "multiCommunity/getSpecificUser", {
          id: community?.leader,
        });
        
        localStorage.setItem("token", responseSpecificUser?.data?.token);
        dispatch(storeUser(responseSpecificUser?.data));
        dispatch(setRefetchMultiCommunityList(true));
        dispatch(setRefetchSpecificUser(true));
        // await fetchUser(api, dispatch, storeUser);
        // const responseUser = await api("get", "users/index");

        // if (responseUser?.status) {
        //   const { data } = responseUser;
        //   if (dispatch && storeUser) dispatch(storeUser(data));
        //   if (data?.token) localStorage.setItem("token", data.token);
        //   // return data;
        // }
        const otherCommunityOptions = await fetchOtherCommunitiesCredentials();
        setCommunityCreated(true);
        setTimeout(() => {
          setIsLoading(false);
          navigate("/leader/onboarding/connection", {
            replace: true,state:{
              previousCommunityConnected,
              otherCommunityOptions
            }
          });
          // setCommunityCreated(false);
        }, 2000);
      } else {
        setIsLoading(false);
        toastify(response?.message || "Failed to create community.");
      }
    } catch (error) {
      console.error("🚀 -> handleNext -> error:", error);
      setIsLoading(false);
    }
  };

  // useEffect(() => {
  //   if (user?.role === "leader") {
  //     if (!user?.onboarding?.isCommunityCreated) {
  //       navigate("/leader/onboarding/community", { replace: true });
  //       return;
  //     }

  //     if (!user?.onboarding?.connect) {
  //       navigate("/leader/onboarding/connection", { replace: true });
  //       return;
  //     }

  //     if (!user?.onboarding?.subscribed) {
  //       navigate("/leader/onboarding/subscription", { replace: true });
  //       return;
  //     }

  //     if (!user?.onboarding?.payment) {
  //       navigate("/leader/onboarding/payout", { replace: true });
  //       return;
  //     }

  //     if (!user?.onboarding?.isVerified) {
  //       if (user?.socialLogin?.discord?.id) {
  //         navigate("/leader/onboarding/importantUpdates", { replace: true });
  //       } else if (user?.socialLogin?.telegram?.id) {
  //         navigate("/leader/onboarding/submitNewEmail", { replace: true });
  //       } else {
  //         navigate("/leader/onboarding/verify", { replace: true });
  //       }
  //       return;
  //     }
  //   }
  // }, [user]);
 
  return (
    <div className="onboarding-modal-wrapper">
      <Modal
        animation={false}
        backdropClassName="onboarding-custom-backdrop"
        centered
        dialogClassName="custom-onboarding-modal"
        show={show}
      >
        <Modal.Body className="figma-drop-shadow">
          {/* <button
            className="reverseArrow"
            onClick={() => {
              if (onBoardingStartContext) {
                setShow(false);
                dispatch(resetOnBoardingStartContext());
                navigate(onBoardingStartContext, { replace: true });
                return;
              }
              navigate("/leader/dashboard", { replace: true });
            }}
            type="button"
          >
            <img alt="" src={longArrow} />
          </button> */}
          <button className="CrossIcon" onClick={handleClose} type="button">
            <img alt="" src={crossBlack} />
          </button>
          <div className="onboardingContentBox">
            <h2 className="title">
              <span>Community Name</span>
              <InfoPopup
                contentItems={[
                  { text: "Community name", type: "heading" },
                  {
                    text: "This is the name of your service. It will be shown on the platform and used for branding in emails sent to your members.",
                    type: "paragraph",
                  },
                ]}
              />
            </h2>
            <p className="desc">Your users will see this</p>
            <div className="formBox">
              <div className="mb-20px">
                <FloatingTextFiled
                  className="onboardingInput"
                  label="Community Name"
                  onChange={(e) => {
                    const value = e.target.value;
                    const sanitizedValue = value.replace(/[^a-zA-Z0-9 ]/g, "");

                    setName(sanitizedValue);
                  }}
                  placeholder="Community Name"
                  value={name}
                  maxLength={30}
                />
              </div>

              <BubbleSvgButton
                className="NextBtn"
                onClick={handleNext}
                text={"Next"}
                type="button"
                variant="black"
                containerStyling={{
                  justifyContent: "center",
                }}
                mainDivStyle={{
                  width: "275px",
                  height: "55px",
                }}
                isLoading={isLoading}
              />
            </div>
          </div>
          <div className="paginationDots">
            <button className="dot active"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
          </div>
          {/* <div className="copyrightBox">
            <p className="">
              Powered by
              <span className="spanMain">
                <img alt="" src={logo_black} />
              </span>
            </p>
          </div> */}
        </Modal.Body>
      </Modal>

      {warn && (
        <CloseModal handleClose={handleClose} setWarn={setWarn} warn={warn} />
      )}
    </div>
  );
};

export default CommunityName;
